import { message } from 'antd';

/**
 * Exibe uma mensagem de sucesso
 * @param {string} msg - Mensagem a ser exibida
 */
export const showSuccessMessage = (msg) => {
  message.success(msg);
};

/**
 * Exibe uma mensagem de erro
 * @param {string} msg - Mensagem a ser exibida
 */
export const showErrorMessage = (msg) => {
  message.error(msg);
};

/**
 * Exibe uma mensagem de informação
 * @param {string} msg - Mensagem a ser exibida
 */
export const showInfoMessage = (msg) => {
  message.info(msg);
};

/**
 * Exibe uma mensagem de aviso
 * @param {string} msg - Mensagem a ser exibida
 */
export const showWarningMessage = (msg) => {
  message.warning(msg);
};


